import { Button, Text, TextField } from "@flat-ui";
import { Stack, TableCell, TableRow } from "@mui/material";
import { CredentialItem } from "@components/dev-features-dialog/features";
import { useState } from "react";

interface Props {
  /** The credential item to display in the row */
  item: CredentialItem;
}

/**
 * @returns A credentials table row with username and password fields plus a save button.
 * The entered values are persisted via the item's onSave callback.
 */
export function CredentialsTableRow({ item }: Props): JSX.Element {
  const [username, setUsername] = useState(item.username);
  const [password, setPassword] = useState(item.password);

  return (
    <TableRow key={item.label}>
      <TableCell sx={{ p: 1 }}>
        <Text variant="heading12">{item.label}</Text>
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Text variant="helpText">{item.description}</Text>
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Stack direction="column" gap={1} sx={{ minWidth: "14rem" }}>
          <TextField
            placeholder="Username"
            text={username}
            onTextChanged={setUsername}
            fullWidth
          />
          <TextField
            placeholder="Password"
            type="password"
            text={password}
            onTextChanged={setPassword}
            fullWidth
          />
          <Button
            variant="secondary"
            size="s"
            onClick={() => item.onSave(username, password)}
            sx={{ justifySelf: "end" }}
          >
            Save
          </Button>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
